//TODO remove `angular.element(document.body).ready(() => ...);` Must work without it.

class AnimatronNotification {
    private readonly options = {timeout: 5000};

    private _timeout: number;
    private type: string;
    private container: ng.IAugmentedJQuery;

    constructor() {
        angular.element(document.body).ready(() => {
            this.container = angular.element(document.querySelector('.animatron_notification_block'));
        });
    }

    showError(message: string, timeout?: number) {
        angular.element(document.body).ready(() => {
            this.showMessage(message, timeout, 'error');
        });
    }

    showSuccess(message: string, timeout?: number) {
        angular.element(document.body).ready(() => {
            this.showMessage(message, timeout, 'success');
        });
    }

    private showMessage(message: string, timeout: number, type: string) {
        this.hideInstantly();

        if (this.type !== type) {
            this.type = type;
            this.hide();
            this.showMessage(message, timeout, type);
            return;
        }
        if (timeout) {
            this.options.timeout = timeout;
        }

        document.querySelector('.animatron_notification_block').innerHTML = '';
        this.container.append(angular.element('<span/>').html(message));
        this.show();
        if (this.options.timeout > 0) {
            clearTimeout(this._timeout);
            this._timeout = setTimeout(() => this.hide(), this.options.timeout);
        }
        const dismiss_btn = angular.element('<a href="#"/>')
            .addClass('close')
            .on('click', event => {
                event.preventDefault();
                this.hide();
            });
        this.container.append(dismiss_btn);
    }

    hide() {
        clearTimeout(this._timeout);
        if (this.container) {
            this.container.removeClass('show');
        }
    }

    private show() {
        this.container.addClass('show').removeClass('hide');
    }

    private hideInstantly() {
        if (this.container) {
            this.container.addClass('hide').removeClass('show');
        }
    }
}

_.notification = new AnimatronNotification();



// WEBPACK FOOTER //
// ./app/assets/javascripts/notification.ts